import Content from '@/views/content'
import ContentMaintList from '@/views/content/maint/content-list.vue'
import ContentPageMaintList from '@/views/content/maint/content-page-list.vue'


export default {
    path: 'Content',
    name: 'Content',
    component: Content,
    children: [{
        path: "/",
        name: 'content-maint',
        component: ContentMaintList,
    },
    {
        path: "page/:id",
        name: 'content-page-maint',
        component: ContentPageMaintList,
    }]
}